export default data => ({ type: 'UPDATE_THEME', data });
